<div *ngIf="shouldShowLeftOpponentCards" class="left-opponent-cards-container">
  <div
    class="left-opponent-cards card-border"
    [ngClass]="{ 'card-border-activate': isLeftOpponentTurnToPlay }"
  >
    <sans-card
      *ngFor="let card of leftOpponentCards; trackBy: cardTrackBy"
      [isVertical]="true"
      [isFaceUp]="shouldShowLeftOpponentCardsFaceUp"
      [card]="card"
      [shouldHighlight]="shouldHighlightCard(card)"
    >
    </sans-card>
  </div>

  <button
    class="show-opponent-button show-right-opponent-button"
    mat-icon-button
    [attr.aria-label]="showRightOpponentCardsAriaLabel"
    (click)="onShowRightOpponentCards()"
  >
    <mat-icon>arrow_forward</mat-icon>
  </button>
</div>

<div
  *ngIf="shouldShowLeftOpponentCards"
  class="left-opponent-name left-opponent-name-left-opponent-cards-container"
>
  <div>
    {{ leftOpponentUsername }}
  </div>

  <div>
    {{ leftOpponentGamePlayerOrderMessage }}
  </div>

  <div *ngIf="shouldShowPassFailStatus">
    {{ leftOpponentPassFailLabel }}
  </div>

  <div *ngIf="shouldShowLeftOpponentTricksWon" class="tricks-won">
    {{ leftOpponentTricksWon }}
  </div>
</div>

<div
  *ngIf="shouldShowRightOpponentCards"
  class="left-opponent-cards-container right-opponent"
>
  <div
    class="left-opponent-cards card-border"
    [ngClass]="{ 'card-border-activate': isRightOpponentTurnToPlay }"
  >
    <sans-card
      *ngFor="let card of rightOpponentCards; trackBy: cardTrackBy"
      [isVertical]="true"
      [isFaceUp]="shouldShowRightOpponentCardsFaceUp"
      [card]="card"
      [shouldHighlight]="shouldHighlightCard(card)"
    >
    </sans-card>
  </div>

  <button
    class="show-opponent-button show-left-opponent-button"
    mat-icon-button
    [attr.aria-label]="showLeftOpponentCardsAriaLabel"
    (click)="onShowLeftOpponentCards()"
  >
    <mat-icon>arrow_backward</mat-icon>
  </button>
</div>

<div
  *ngIf="shouldShowRightOpponentCards"
  class="left-opponent-name left-opponent-name-left-opponent-cards-container"
>
  <div>
    {{ rightOpponentUsername }}
  </div>

  <div>
    {{ rightOpponentGamePlayerOrderMessage }}
  </div>

  <div *ngIf="shouldShowPassFailStatus">
    {{ rightOpponentPassFailLabel }}
  </div>

  <div *ngIf="shouldShowRightOpponentTricksWon" class="tricks-won">
    {{ rightOpponentTricksWon }}
  </div>
</div>

<div class="table-section">
  <sans-game-info-section
    class="game-info-section game-info-section-table-section"
    [game]="game"
    [talonCards]="talonCards"
    [userPlayerScoreCard]="userPlayerScoreCard"
    [leftOpponentPlayerScoreCard]="leftOpponentPlayerScoreCard"
    [rightOpponentPlayerScoreCard]="rightOpponentPlayerScoreCard"
  ></sans-game-info-section>

  <div class="table">
    <div class="left-opponent-name left-opponent-name-table">
      <div>
        {{ leftOpponentUsername }}
      </div>

      <div>
        {{ leftOpponentGamePlayerOrderMessage }}
      </div>

      <div *ngIf="shouldShowPassFailStatus">
        {{ leftOpponentPassFailLabel }}
      </div>

      <div *ngIf="shouldShowLeftOpponentTricksWon" class="tricks-won">
        {{ leftOpponentTricksWon }}
      </div>
    </div>

    <img
      class="logo-image"
      [ngSrc]="logoAssets.imgSrc"
      [width]="400"
      [height]="400"
      [alt]="logoAssets.altImg"
      priority="high"
    />

    <div class="user-trick" *ngIf="shouldShowUserTrick">
      <sans-card [isVertical]="true" [isFaceUp]="true" [card]="userTrick.card">
      </sans-card>
    </div>

    <div class="right-opponent-trick" *ngIf="shouldShowRightOpponentTrick">
      <sans-card [isFaceUp]="true" [card]="rightOpponentTrick.card">
      </sans-card>
    </div>

    <div class="left-opponent-trick" *ngIf="shouldShowLeftOpponentTrick">
      <sans-card
        [isVertical]="true"
        [isFaceUp]="true"
        [card]="leftOpponentTrick.card"
      >
      </sans-card>
    </div>

    <div class="talon-cards" *ngIf="shouldShowTalonCardsOnTable">
      <sans-card
        *ngFor="let card of talonCards; trackBy: cardTrackBy"
        [isVertical]="true"
        [isFaceUp]="shouldShowTalonCardsOnTableFaceUp"
        [card]="card"
        [isSelectable]="isTalonCardsSelectable"
        [shouldHighlight]="shouldHighlightCard(card)"
        (click)="onTalonCardSelected(card)"
      >
      </sans-card>
    </div>

    <div
      class="user-info-container user-info-container-table"
      [ngClass]="{ 'with-user-actions': shouldShowUserActions }"
    >
      <div class="user-actions" *ngIf="shouldShowUserActions">
        <button
          *ngFor="let userAction of userActions"
          mat-flat-button
          color="primary"
          class="user-action"
          (click)="onUserActionSelected(userAction)"
        >
          {{ userAction.buttonLabel }}
        </button>
      </div>

      <div
        class="user-info"
        [ngClass]="{ 'with-user-actions': shouldShowUserActions }"
      >
        <div>{{ userUsername }}</div>

        <div>
          {{ userGamePlayerOrderMessage }}
        </div>

        <div *ngIf="shouldShowPassFailStatus">
          {{ userPassFailLabel }}
        </div>

        <div *ngIf="shouldShowUserTricksWon" class="tricks-won">
          {{ userTricksWon }}
        </div>
      </div>
    </div>
  </div>

  <div class="right-opponent-section right-opponent-section-table-section">
    <div class="right-opponent-name">
      <div>
        {{ rightOpponentUsername }}
      </div>

      <div>
        {{ rightOpponentGamePlayerOrderMessage }}
      </div>

      <div *ngIf="shouldShowPassFailStatus">
        {{ rightOpponentPassFailLabel }}
      </div>

      <div
        *ngIf="shouldShowRightOpponentTricksWon"
        class="tricks-won right-opponent-tricks-won"
      >
        {{ rightOpponentTricksWon }}
      </div>
    </div>

    <div class="right-opponent-cards">
      <div class="card-border" [ngClass]="{ 'card-border-activate': isRightOpponentTurnToPlay }">
        <sans-card
          *ngFor="let card of rightOpponentCards; trackBy: cardTrackBy"
          [isVertical]="false"
          [isFaceUp]="shouldShowRightOpponentCardsFaceUp"
          [card]="card"
          [shouldHighlight]="shouldHighlightCard(card)"
        >
        </sans-card>
      </div>
    </div>
  </div>
</div>

<div
  class="user-actions user-actions-below-table"
  *ngIf="shouldShowUserActions"
>
  <button
    *ngFor="let userAction of userActions"
    mat-flat-button
    color="primary"
    class="user-action"
    (click)="onUserActionSelected(userAction)"
  >
    {{ userAction.buttonLabel }}
  </button>
</div>

<div
  class="user-info user-info-below-table"
  [ngClass]="{ 'with-user-actions': shouldShowUserActions }"
>
  <div>{{ userUsername }}</div>

  <div>
    {{ userGamePlayerOrderMessage }}
  </div>

  <div *ngIf="shouldShowPassFailStatus">
    {{ userPassFailLabel }}
  </div>

  <div *ngIf="shouldShowUserTricksWon" class="tricks-won">
    {{ userTricksWon }}
  </div>
</div>

<div class="user-section">
  <div
    class="user-cards card-border"
    [ngClass]="{ 'card-border-activate': isUserTurnToPlay }"
  >
    <sans-card
      *ngFor="let card of userCards; trackBy: cardTrackBy"
      [isVertical]="true"
      [isFaceUp]="true"
      [card]="card"
      [isSelectable]="isUserCardsSelectable"
      (click)="onUserCardSelected(card)"
      [shouldHighlight]="shouldHighlightCard(card)"
    >
    </sans-card>
  </div>
</div>

<sans-game-info-section
  class="game-info-section game-info-section-bottom"
  [game]="game"
  [talonCards]="talonCards"
  [userPlayerScoreCard]="userPlayerScoreCard"
  [leftOpponentPlayerScoreCard]="leftOpponentPlayerScoreCard"
  [rightOpponentPlayerScoreCard]="rightOpponentPlayerScoreCard"
></sans-game-info-section>
